import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommentEstablishmentService } from '../service/comment.service';
import { finalize } from 'rxjs';
import { CommentFormComponent } from "../commentForm/commentForm.component";

@Component({
  selector: 'comment-estblishment',
  imports: [CommonModule, CommentFormComponent],
  templateUrl: './commentEstblishment.component.html',
  styleUrl: './commentEstblishment.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentEstblishmentComponent {
  @Input() shopingCart: string = '';
  @ViewChild('commentForm') commentForm!: CommentFormComponent;
  @Output() FormSend = new EventEmitter<boolean>();
  constructor(
    private commentEstablishmentService: CommentEstablishmentService,
  ) {

  }



  OnSubmit(comment: { comment: string, starts: number, shopingCart: string }) {
    this.commentEstablishmentService.commentEstablishment(comment).pipe(
      finalize(() => {
        this.commentForm.resetLoading();
      })
    ).subscribe({
      next: (response) => {
       
        this.FormSend.emit(true);
      },
      error: (error) => {
        console.error('Error al enviar comentario:', error);
      }
    });
  }




}
